import { useState } from "react";
import PatientOveriew from "./PatientOveriew";
import PatientPrescription from "./PatientPrescription";
import PatientReports from "./PatientReports";
import PatientBilling from "./PatientBilling";
import ClinicPatientAppointments from "./ClinicPatientAppointments";

const PatientTab = ({patientViewData,medicalInfo,basicInfo}) => {
  const [activeTab, setActiveTab] = useState("overview");

  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
      activeTab === key
        ? "bg-white text-black shadow-sm"
        : "text-muted-foreground hover:text-black"
    }`;

  return (
    <div className="space-y-4">
      <div className="bg-[#f5f5f5] grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 bg-muted p-1 rounded-md">
        <button onClick={() => setActiveTab("overview")} className={tabButtonStyle("overview")}>
          Overview
        </button>
        <button onClick={() => setActiveTab("appointments")} className={tabButtonStyle("appointments")}>
          Appointments
        </button>
        <button onClick={() => setActiveTab("prescriptions")} className={tabButtonStyle("prescriptions")}>
          Prescriptions
        </button>
        <button onClick={() => setActiveTab("lab-results")} className={tabButtonStyle("lab-results")}>
          Lab Results
        </button>
        <button onClick={() => setActiveTab("billing")} className={tabButtonStyle("billing")}>
          Billing
        </button>
      </div>

      {/* Tab Content */}
      <div className="p-4 border rounded-lg bg-white shadow-sm">
        {activeTab === "overview" && <PatientOveriew patientUserUniqueID={patientViewData?.basicInfo?.useruniqueid} patientViewData={patientViewData} medicalInfo={medicalInfo} basicInfo={basicInfo}/>}
        {activeTab === "appointments" && <ClinicPatientAppointments 
        patientViewData={patientViewData} patientUserUniqueID={patientViewData?.basicInfo?.useruniqueid}/>}
        {activeTab === "prescriptions" && <PatientPrescription patientUserUniqueID={patientViewData?.basicInfo?.useruniqueid}/>}
        {activeTab === "lab-results" &&  <PatientReports patientUserUniqueID={patientViewData?.basicInfo?.useruniqueid}/>}
        {activeTab === "billing" &&  <PatientBilling patientUserUniqueID={patientViewData?.basicInfo?.useruniqueid}/>}
      </div>
    </div>
  );
};

export default PatientTab;
